import { formatNumber } from "helpers/system";
import React from "react";

const Table = ({ cells, isMulti, tableName, setValue, data }) => {
    return (
        <div className="table-hover table-responsive text-nowrap">
            <table className="table table-sm">
                {isMulti && (
                    <thead>
                        <tr>
                            <th />
                            {data.map((item, index) => (
                                <th key={index}>{item.columnName || item.logistDisplayName}</th>
                            ))}
                        </tr>
                    </thead>
                )}
                <tbody>
                    {cells.map((cell, index) => {
                        const { label, propName, disabled } = cell;
                        return (
                            <tr key={index}>
                                <td className="col-4">{label}</td>
                                {(isMulti ? data : [data]).map((item, index) => {
                                    const setValueProps = (value) => ({
                                        logistId: item.logistId,
                                        name: propName,
                                        tableName,
                                        value,
                                    });
                                    const onInputChange = (e) => {
                                        let caret = e.target.selectionStart;
                                        const element = e.target;
                                        const val = element.value;
                                        const numberStr = val.replace(/[^0-9.,]/g, "").replace(".", ","); // remove everything except numbers, dot and comma (1000.111)

                                        // create formatted result 1 000.11
                                        let result;
                                        if (numberStr.includes(",")) {
                                            // it needs because parseFloat remove comma without number after him
                                            const [intNum, fractionalNum] = numberStr.split(",");
                                            result = `${formatNumber(Number(intNum))},${
                                                fractionalNum ? formatNumber(Number(fractionalNum.substring(0, 2))) : ""
                                            }`;
                                        } else {
                                            result = formatNumber(Number(numberStr));
                                        }

                                        // calculate caret position after formatting
                                        if (result.length > val.length) {
                                            caret++;
                                        }
                                        window.requestAnimationFrame(() => {
                                            element.selectionStart = caret;
                                            element.selectionEnd = caret;
                                        });

                                        setValue({ ...setValueProps(result) });
                                    };
                                    return (
                                        <td key={index}>
                                            <input
                                                className="field-wrap__input field-wrap__input--table"
                                                pattern="[0-9]+([.,][0-9]+)?"
                                                name={propName}
                                                onBlur={(e) => !e.target.value && setValue({ ...setValueProps(0) })}
                                                value={
                                                    typeof item[propName] === "string"
                                                        ? item[propName]
                                                        : formatNumber(item[propName])
                                                }
                                                onChange={onInputChange}
                                                disabled={disabled}
                                            />
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
